import { createSlice } from '@reduxjs/toolkit';
import {
  fetchJourneys,
  fetchJourneyById,
  createJourney,
  updateJourney,
  deleteJourney,
  copyJourneyToClinic
} from '../thunks/journeyThunk';
import { fetchJourneyTemplates } from '../thunks/clientJourneyThunk';

const journeySlice = createSlice({
  name: 'journeys',
  initialState: {
    journeys: [],
    selectedJourney: null,
    status: 'idle',
    error: null,
    journeyTemplates: [],
  },
  reducers: {
    setSelectedJourney: (state, action) => {
      state.selectedJourney = action.payload;
    },
    clearSelectedJourney: (state) => {
      state.selectedJourney = null;
    },
    clearJourneyTemplates: (state) => {
      state.journeyTemplates = [];
      state.status = 'idle';
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJourneys.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchJourneys.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.journeys = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchJourneys.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(fetchJourneyById.fulfilled, (state, action) => {
        state.selectedJourney = action.payload;
      })
      .addCase(createJourney.fulfilled, (state, action) => {
        state.journeys.push(action.payload);
        state.selectedJourney = action.payload;
      })
      .addCase(updateJourney.fulfilled, (state, action) => {
        const idx = state.journeys.findIndex(j => j._id === action.payload._id);
        if (idx !== -1) state.journeys[idx] = action.payload;
        state.selectedJourney = action.payload;
      })
      .addCase(deleteJourney.fulfilled, (state, action) => {
        state.journeys = state.journeys.filter(j => j._id !== action.meta.arg);
        state.selectedJourney = null;
      })
      .addCase(copyJourneyToClinic.fulfilled, (state, action) => {
        state.journeys.push(action.payload);
      })
      .addCase(fetchJourneyTemplates.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchJourneyTemplates.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.journeyTemplates = action.payload;
      })
      .addCase(fetchJourneyTemplates.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { setSelectedJourney, clearSelectedJourney, clearJourneyTemplates } = journeySlice.actions;
export default journeySlice.reducer;